import { formatTime } from "@clipboard-health/date-time";
import { Alert, AlertTitle } from "@mui/material";
import { parseISO } from "date-fns";

interface GeofenceWarningBannerProps {
  /** Variant determines the warning message */
  variant: "entered-building" | "still-in-building";
  /** Time when worker entered the facility geofence (for "entered-building" variant) */
  geofenceEntryTime?: string;
  /** Timezone for time formatting */
  timezone?: string;
}

/**
 * Amber warning banner shown when geofence data conflicts with the reported issue.
 *
 * Two variants:
 * - "entered-building": Heading + worker entered the building at {time} (No Show paths)
 * - "still-in-building": Worker is still in the building (Left Early / Cancel paths)
 */
export function GeofenceWarningBanner(props: GeofenceWarningBannerProps) {
  const { variant, geofenceEntryTime, timezone } = props;

  if (variant === "entered-building") {
    return (
      <Alert severity="warning" sx={{ borderRadius: 2 }}>
        <AlertTitle>Professional in the building</AlertTitle>
        {getEnteredBuildingMessage(geofenceEntryTime, timezone)}
      </Alert>
    );
  }

  return (
    <Alert severity="warning" sx={{ borderRadius: 2 }}>
      Our location data shows that this professional is still in the building.
    </Alert>
  );
}

function getEnteredBuildingMessage(geofenceEntryTime?: string, timezone?: string): string {
  if (!geofenceEntryTime) {
    return "Our location data shows that this professional entered your building.";
  }

  const time = formatTime(parseISO(geofenceEntryTime), { timeZone: timezone });

  return `Our location data shows that this professional entered your building at ${time}.`;
}
